<template>
  <div class="row">
    <div class="col-md-4 mb-4" :key="index" v-for="(item, index) in value">
      <div class="grid-item h-100 mb-3" style="position: relative;">
        <!-- good and damaged display this when no audit status due to both collateral status need an action to perform -->
        <div style="position: absolute;z-index: 1;width: 100%;height: 45%;background: rgba(255,255,255, .5);" v-if="(item.auditStatus == null||item.auditStatus == 'denied') && item.contractStatus != 'contract_cancelled'">
          <span class="m-0 badge badge-soft-danger py-2 c-pointer" style="background: #AE2523;color: #fff;position: absolute;top: 40%;left: 32%;" @click="view(item)">
            <i class="mdi mdi-alert-circle"></i>
            View Action Required
          </span>
        </div>
        <b-card
          class="h-100 store-photo-thumbnail p-0"
          >
          <template #header>
            <div class="ratio ratio-4x3">
            <b-card-img 
              class="card-store-photo img-fluid"
              :src="item.storePhoto" 
              alt="Card image" 
              style="object-fit: cover;"
            ></b-card-img>
          </div>
          </template>
          
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <div :title="item.storeName" class="cursor-pointer store-name text-primary text-capitalize" @click="view(item)">
              {{item.storeName | truncator(30,'...')}}
            </div>
          </div>
          <p class="ts-10"><span class="capitalize">{{item.type}}</span> | <span>{{item.dimension}}</span> | <span>{{item.placement}}</span></p>

          <div class="row">
            <div class="col-sm-6" :title="item.businessType">
              <i class="bx bx-store me-2"></i> <span class="ts-11">{{item.businessType | truncator(15,'...')}}</span>
            </div>
            <!-- <div class="col-sm-6">
              <i class="bx bx-calendar me-2"></i> <span class="ts-11">{{item.duration}} months</span>
            </div> -->
            <!-- <div class="col-sm-6">
              <i class="bx bx-mobile me-2"></i> <span class="ts-11">{{item.mobileNumber}}</span>
            </div> -->
            <div class="col-sm-6" :title="item.fullAddress">
              <i class="bx bx-map-pin me-2"></i> <span class="ts-11">{{item.fullAddress | truncator(15,'...')}}</span>
            </div>
          </div>

          <div class="mt-3">
            <button  @click="view(item)" class="btn btn-primary float-end py-1 px-4">
              View Details
            </button>
            <div class="rental-price">₱ {{item.price | toCurrency}}/<small>month</small></div>
          </div>
          
          <template #footer>
            <b class="me-2">Collateral Status:</b>
            <span :class="[item.collateralStatus == 'Good'? 'text-success':'text-danger']">{{ item.collateralStatus }}</span>
          </template>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import {layoutMethods, layoutComputed} from "@/state/helpers";

export default {
  props: ['value'],
  components: {
  },
  computed: {
    ...layoutComputed
  },
  methods: {
    ...layoutMethods,
    view(item){
      this.$emit("viewFullDetails", item);
    }
  },
  data() {
    return {
    };
  },
  mounted(){
    // this.$toast.showToast('success', "Successful test", "Your top-up was successfully added to you wallet.");
  }
};
</script>
<style>
.store-photo-thumbnail > img {
  /* height: 180px; */
  height: auto;
  width: auto;
  object-fit: cover;
}
.sub-listing-item {
  font-weight: 600;
  font-size: 7px;
  background: rgba(0, 98, 255, 0.1);
  padding: 2px 10px 2px 10px;
  border-radius: 8px;
}

.store-photo-thumbnail .card-header {
  padding: 0;
}

.card-store-photo {
  border-radius: 0;
}
</style>